import { FlexBetween, FlexBox, FlexRow } from "components/flex-box";
import { H5 } from "components/Typography";
import Button from "@mui/material/Button";
import { colors, formatCurrency } from "common";

import { useAppSelector } from "hooks/use-app-selector";
import { useIsMobile } from "hooks";
import modules from "modules";
import { useLoginStatus } from "hooks/useLoginStatus";
import { FC } from "react";
import { useDialogueShow } from "hooks/useDialogue";

const { selectors: pcBuilderSelectors } = modules.pcBuilder;

type Props = {
  toggleDecision?: () => void;
  isScreenshot?: boolean;
};

const RowTotal: FC<Props> = ({ toggleDecision, isScreenshot }) => {
  const isMobile = useIsMobile();
  const { isUserLogin } = useLoginStatus();
  const { showLoginFormOpen } = useDialogueShow();
  const isLogin = isUserLogin;

  const totalAmount = useAppSelector(
    pcBuilderSelectors.selectBuildPartsTotalAmount
  );

  const dynamicStyle = isScreenshot
    ? null
    : { borderBottomLeftRadius: 8, borderBottomRightRadius: 8 };

  if (isMobile && !isScreenshot) {
    return (
      <FlexBox
        flex={1}
        flexDirection="column"
        bgcolor={colors.primary}
        mt={2}
        py={2}
        px={4}
        sx={{ borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}
      >
        <FlexBetween alignItems="center">
          <H5 color="white" fontWeight={600}>
            {"SUBTOTAL"}
          </H5>
          <H5 color="white" fontWeight={600}>
            {formatCurrency(totalAmount)}
          </H5>
        </FlexBetween>
        <FlexBox mt={2}>
          {totalAmount ? (
            <Button
              disabled={!totalAmount}
              color="secondary"
              variant="contained"
              style={{ width: "100%", borderRadius: 4 }}
              sx={{
                height: 30,
                bgcolor: "#CF151A",
              }}
              onClick={isLogin ? toggleDecision : showLoginFormOpen}
            >
              ADD TO CART
            </Button>
          ) : null}
        </FlexBox>
      </FlexBox>
    );
  }

  return (
    <FlexRow
      flex={1}
      bgcolor={colors.primary}
      py={1}
      alignItems="center"
      sx={dynamicStyle}
    >
      <FlexBox flex={1} alignItems="center" justifyContent="center">
        <H5 py={0} px={2} color="white" fontWeight={600}>
          {"SUBTOTAL"}
        </H5>
      </FlexBox>
      <FlexBox flex={3.6} height={20}></FlexBox>
      <FlexBox flex={1}>
        <H5 py={0} px={2} color="white" fontWeight={600}>
          {formatCurrency(totalAmount)}
        </H5>
      </FlexBox>
      {/* <FlexBox flex={1}>
        {totalAmount ? (
          <Button
            disabled={!totalAmount}
            color="secondary"
            variant="contained"
            style={{ borderRadius: 4 }}
            sx={{
              height: 30,
              paddingLeft: 4,
              paddingRight: 4,
              bgcolor: "#CF151A",
            }}
            onClick={isLogin ? toggleDecision : showLoginFormOpen}
          >
            ADD TO CART
          </Button>
        ) : null}
      </FlexBox> */}
    </FlexRow>
  );
};

export default RowTotal;
